module.exports = __webpack_public_path__ + "static/img/postnord.f2d813e6.png";